export default __webpack_public_path__ + "pgnv-assets/2cfbd2e0b7cb769b0d21275281961d54.png";